import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import TermsAndConditions from '../components/TermsOfService';

const TosRoute = () => {
  return (
    <>
      <Helmet>
        <title>AskPics — Terms of Service</title>
        <meta name="description" content="Read the AskPics Terms of Service to understand the rules and guidelines for using the app." />
        <link rel="canonical" href="https://askpics.app/tos" />
      </Helmet>
      <div>
        <main>
          <TermsAndConditions />
        </main>
      </div>
    </>
  );
};

export default TosRoute;
